import {_User as User} from "./_User";

export const GiftCardAPI = {
    User: User
};